import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import moIndex from '../store';
import HeadPdf from '../component/head-pdf';
import Title from '../component/title';
import FootPdf from '../component/foot-pdf';
import Pdf from '../component/pdf';
import './scss/hot-role.scss';
import moDemandPdf from './store';
import QuantityChart from './component/quantity-chart';
import HotRoleTable from './component/hot-role-table';
import { cloneDeep, isEmpty } from 'lodash';
import { getTableList, isNumbers } from '../store/common';
import { toJS } from 'mobx';

interface IProps {}
interface IState {}

const HotRole = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { hotListTop30, hotRoleTime } = moDemandPdf;

  const getOneList = useMemo(() => {
    let list: any = [];
    if (!isEmpty(hotListTop30) && !isEmpty(hotListTop30?.category_points)) {
      const data = cloneDeep(hotListTop30.category_points);
      const res  = data.sort((a:any, b:any) => a.amount_rank - b.amount_rank);
      list = res.slice(0, 6);
    }
    return list;
  }, [hotListTop30]);

  const getTwoList = useMemo(() => {
    let list: any = [];
    if (!isEmpty(hotListTop30) && !isEmpty(hotListTop30?.category_points)) {
      const data = cloneDeep(hotListTop30.category_points);
      const res  = data.sort((a:any, b:any) => a.amount_rank - b.amount_rank);
      const result = res.slice(6);
      list = getTableList(result, 24);
    }
    return list;
  }, [hotListTop30]);

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section id="hot-role">
      <Pdf>
        <section className="hot-role-pdf-warp">
          <HeadPdf onetitle="人力资源核心指标" twotitle={moIndex.industry.name} />
          <section className="hot-role-top-title">
            <Title title="热门职能" bigTitle="人力需求" tag={isNumbers(hotRoleTime) ? `${hotRoleTime}年` : hotRoleTime} />
            <p className="details">
              统计说明：呈现该行业下，当期招聘量前30的细分职能（不包含支持职能）。
            </p>
            <p className="details">
              用户可根据这些职能的招聘量、招聘量涨幅、招聘薪酬、招聘薪酬涨幅进行自由组合，对细分职
            </p>
            <p className="details" style={{ marginBottom: '10px' }}>
              能进行招聘分析。象限分界线分别为X轴和Y轴上数据的50分位值。
            </p>
            <QuantityChart />
            <HotRoleTable list={getOneList} />
          </section>
          <FootPdf />
        </section>
      </Pdf>

      {getTwoList?.map((res: any, r: any) => {
        return (
          <section key={r}>
            <Pdf>
              <section className="hot-role-pdf-warp">
                <HeadPdf onetitle="人力资源核心指标" twotitle={moIndex.industry.name} />
                <section className="hot-role-top-title">
                  <Title title="热门职能" bigTitle="人力需求" tag={isNumbers(hotRoleTime) ? `${hotRoleTime}年` : hotRoleTime} />
                  <p className="details">
                    统计说明：呈现该行业下，当期招聘量前30的细分职能（不包含支持职能）。
                  </p>
                  <p className="details">
                    用户可根据这些职能的招聘量、招聘量涨幅、招聘薪酬、招聘薪酬涨幅进行自由组合，对细分职
                  </p>
                  <p className="details">
                    能进行招聘分析。象限分界线分别为X轴和Y轴上数据的50分位值。
                  </p>
                  <HotRoleTable list={res} />
                </section>
                <FootPdf />
              </section>
            </Pdf>
          </section>
        );
      })}
    </section>
  );
};

export default observer(HotRole);
